<template>
  <div>
    <AHeadline
      v-if="config.content_type === 'Headline'"
      :text="config.text"
      :type="config.type"
      :style-class="config.style_class"
      :color="config.color"
      :translate="config.translate"
    />

    <ADivider v-else-if="config.content_type === 'Divider'" />

    <p v-else-if="config.content_type === 'Text'" :class="config.style_class" :style="{ color: config.color }">
      {{ config.translate === false ? config.text : $t(config.text || '') }}
    </p>
    
    <ABenefits v-else-if="config.content_type === 'Benefits'" :benefits="config.benefits" />
    <AImageText v-else-if="config.content_type === 'ImageText'" :image="config.image" :text="config.text" />
  </div>
</template>

<script setup lang="ts">
import AHeadline from '@/components/atoms/content/headline/A-Headline.vue'
import ADivider from '@/components/atoms/content/divider/A-Divider.vue'
import ABenefits from '@/components/atoms/content/benefits/A-Benefits.vue'
import AImageText from '@/components/atoms/content/image-text/A-ImageText.vue'
import type { MContentProps } from './m-content-props'

defineProps<MContentProps>()
</script>
